// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2RO2g","image":"styles_image__1L-kF","text":"styles_text__KiFlo"};